import React, { useState, useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { GET } from '../../utils/axios';
import { formatToK } from '../../utils/global-functions';
import { hasPermission } from '../../scenes/Setting/permissionHelper';
import './NavbarStyle.css';
import config from '../../config/config';
const NavBar = () => {
  const location = useLocation();
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [badgeCount, setBadgeCount] = useState(0);
  const permissionsData = useSelector(
    (state) => state.rolePermissionReducer.userPermissionData
  );
  const headerLocation = useSelector(
    ({ locationReducer }) => locationReducer.headerLocationValue
  );
  // Fetch badge count
  const fetchBadgeCount = async (headerLocation) => {
    try {
      let response = await GET(`edi204/badge-counts/${headerLocation}`);
      if (response?.httpCode === 200) {
        const badgeData = response.data.find((e) => e.FLAG === 'P');
        setBadgeCount(badgeData ? badgeData['TOTAL_ROWS'] : 0);
      }
    } catch (error) {
      console.error('Failed to fetch badge count:', error);
    }
  };
  useEffect(() => {
    if (typeof headerLocation !== 'undefined' && headerLocation > 0)
      fetchBadgeCount(headerLocation);
  }, [headerLocation]);
  const taps = [
    {
      label: 'Orders',
      index: 0,
      dropdown: [
        { label: 'Orders', pathname: '/orders', perm: 'orders' },
        { label: 'Templates', pathname: '/templates', perm: 'templates' },
        { label: 'EDI Orders', pathname: '/edi-orders', perm: 'ediorders' },
        { label: 'Trace', pathname: '/trace', perm: 'trace' },
        { label: 'Completed Order', pathname: '/order/completed-order', perm: 'completed' },
      ]
    },
    {
      pathname: '/ratebook',
      label: 'Ratebook',
      index: 2,
      perm: 'ratebook'
    },
    {
      pathname: '/dispatch',
      label: 'Dispatch',
      index: 3,
      perm: 'dispatch'
    },
    {
      label: 'Maintenance',
      index: 4,
      dropdown: [
        { label: 'Shipper/Consignee', pathname: '/shipperconsignee', perm: 'shipperconsignee' },
        { label: 'Truck/Driver', pathname: '/truckdriver', perm: 'truckdriver' },
        { label: 'Pickup/Disposition', pathname: '/equip/pick-up/dispo', perm: 'pickupdisposition' },
        { label: 'Order By', pathname: '/order-by', perm: 'orderby' },
        { label: 'Bill To', pathname: '/bill-to', perm: 'billto' }
      ]
    },
    {
      label: 'Reports',
      index: 5,
      dropdown: [
        { label: 'View PT Report', pathname: '/purchase-transportation-report', perm: 'reports' },
        { label: 'Billing Report', pathname: '/billing-report', perm: 'reports' },
        { label: 'PT Paid w/o Revenue Report', pathname: '/pt-paid-without-revenue-report', perm: 'reports' },
        { label: 'Customer Revenue', pathname: '/revenue-by-customer-report', perm: 'reports' }
      ]
    },
    {
      label: 'Documents',
      index: 6,
      dropdown: [
        { label: 'Search', pathname: '/document/search', perm: 'documents' },
        { label: 'Upload', pathname: '/document/upload', perm: 'documents' },
        { label: 'Req Doc Audit', pathname: '/document/req-doc-audit', perm: 'documents' }
      ]
    },
    {
      label: 'Settings',
      index: 6,
      isSetting:true,
      dropdown: [
        { label: 'Roles', pathname: '/settings/role/list', perm: 'roles' },
        { label: 'Users', pathname: '/settings/user/list', perm: 'users' }
      ]
    }
  ];
  const handleMouseEnter = (index) => setActiveDropdown(index);
  const handleMouseLeave = () => setActiveDropdown(null);
  // :point_down: Helper: Check if dropdown has at least one permitted item
  // const isDropdownAllowed = (dropdown) => {
  //   if (!dropdown) return true;
  //   return dropdown.some((item) => hasPermission(permissionsData, item.perm));
  //   // return true
  // };
  const isDropdownAllowed = (dropdown) => {
    if (!dropdown) return true;
    return dropdown.some((item) =>
      hasPermission(permissionsData, item.perm, "VIEW_ONLY")
    
    );
  };
  return (
    <div style={{ justifyContent: 'flex-start', display: 'flex', alignItems: 'center', height: '100%' }}>
      {taps.map(({ pathname, label, dropdown, perm,isSetting }, i) => {
        // Skip rendering this menu if permission fails
        if(!config.enablePermissionCheck && isSetting) return null
        if (dropdown && !isDropdownAllowed(dropdown)) return null;
        if (!dropdown && perm && !hasPermission(permissionsData, perm)) return null;
        return (
          <div key={i} style={{ position: 'relative' }}>
            {dropdown ? (
              <div
                onMouseEnter={() => handleMouseEnter(i)}
                onMouseLeave={handleMouseLeave}
                style={{
                  marginRight: '20px',
                  marginLeft: '30px',
                  cursor: 'pointer',
                  color: 'white',
                  fontWeight: location?.pathname === pathname ? '900' : '400'
                }}
              >
                {i === 0 && badgeCount > 0 && (
                  <span
                    style={{
                      position: 'absolute',
                      top: '-16px',
                      right: '-5px',
                      background: 'red',
                      color: 'white',
                      fontSize: '12px',
                      fontWeight: 'bold',
                      borderRadius: '50%',
                      padding: '5px 8px',
                      zIndex: 1000
                    }}
                  >
                    {formatToK(badgeCount)}
                  </span>
                )}
                {label}
                {activeDropdown === i && (
                  <div
                    style={{
                      position: 'absolute',
                      top: '100%',
                      left: 0,
                      backgroundColor: 'white',
                      padding: '10px',
                      borderRadius: '5px',
                      zIndex: 999,
                      boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
                      whiteSpace: 'nowrap'
                    }}
                  >
                    {dropdown
                     .filter((item) => hasPermission(permissionsData, item.perm, (item.pathname==="/document/upload"?"READ_WRITE":"VIEW_ONLY")))
                      .map(({ label, pathname }, index) => (
                        <Link
                          key={index}
                          to={pathname}
                          style={{
                            display: 'block',
                            color:
                              i === 0 && index === 2 && badgeCount > 0
                                ? 'red'
                                : '#0911A7',
                            textDecoration: 'none',
                            padding: '10px 15px',
                            margin: '5px 0',
                            backgroundColor: '#F9F9F9',
                            borderRadius: '5px',
                            boxShadow:
                              '0px 2px 4px rgba(0, 0, 0, 0.1), 0px 4px 8px rgba(0, 0, 0, 0.1)',
                            whiteSpace: 'nowrap',
                            transition: 'background-color 0.3s ease'
                          }}
                          className="menu-link"
                        >
                          {label}
                        </Link>
                      ))}
                  </div>
                )}
              </div>
            ) : (
              <Link
                style={{
                  marginRight: '20px',
                  marginLeft: '30px',
                  textDecoration: 'none',
                  outline: 'none',
                  color: 'white',
                  fontWeight: location?.pathname === pathname ? '900' : '400'
                }}
                to={pathname}
              >
                {label}
              </Link>
            )}
          </div>
        );
      })}
    </div>
  );
};
export default NavBar;